// extracted by mini-css-extract-plugin
export var keepCardHistory = "pages-account-__LinkCharlieCard-module___keepCardHistory";
export var labelOverride = "pages-account-__LinkCharlieCard-module___labelOverride";
export var radioCharlieLabel = "pages-account-__LinkCharlieCard-module___radioCharlieLabel";
export var radioCharlieOption = "pages-account-__LinkCharlieCard-module___radioCharlieOption";
export var radioCharlieType = "pages-account-__LinkCharlieCard-module___radioCharlieType";
export var tooltipCcv = "pages-account-__LinkCharlieCard-module___tooltipCcv";
export var tooltipContainer = "pages-account-__LinkCharlieCard-module___tooltipContainer";
export var tooltipOverride = "pages-account-__LinkCharlieCard-module___tooltipOverride";